export function BrandTitle() {
	return (
		<span className="min-w-0 truncate text-xl font-bold tracking-tight">
			Контент <span className="text-primary">Могущество</span>
		</span>
	)
}
